// Base route paths
const APP = '/app';
const DISPATCH = '/app/dispatch';
const MERCHANT = '/app/merchant';
const DRIVER = '/app/driver';

// Route paths
export const ROUTES = {
    // Base paths
    APP,
    DISPATCH,
    MERCHANT,
    DRIVER,

    // Driver routes
    DRIVER_DASHBOARD: DRIVER,
    DRIVER_REPORTS: `${DRIVER}/reports`,
    
    // Dispatch routes
    DISPATCH_DASHBOARD: DISPATCH,
    DISPATCH_SEARCH: `${DISPATCH}/search`,
    DISPATCH_DELIVERIES: `${DISPATCH}/deliveries`,
    DISPATCH_DELIVERIES_RECURRING: `${DISPATCH}/deliveries/recurring`,
    /** @param {string|number} orid Order ORID @param {string|number} [segment] Delivery leg sequence (1-based) */
    DISPATCH_DELIVERY_DETAIL: (orid, segment) => {
        const orderId = orid ?? '';
        if (segment != null && segment !== '') {
            return `${DISPATCH}/deliveries/${orderId}/${segment}`;
        }
        return `${DISPATCH}/deliveries/${orderId}`;
    },
    DISPATCH_ORDERS: `${DISPATCH}/orders`,
    DISPATCH_ORDER_DETAIL: (orid) => `${DISPATCH}/orders/${orid ?? ''}`,
    DISPATCH_DRIVERS: `${DISPATCH}/drivers`,
    DISPATCH_DRIVER_REVENUE: (id) => `${DISPATCH}/drivers/${id ?? ''}/revenue`,
    DISPATCH_DRIVERS_ONLINE: `${DISPATCH}/drivers/online`,
    DISPATCH_DRIVERS_INACTIVE: `${DISPATCH}/drivers/inactive`,
    DISPATCH_DRIVERS_INCIDENTS: `${DISPATCH}/drivers/incidents`,
    DISPATCH_DRIVERS_LOCATIONS_HISTORY: `${DISPATCH}/drivers/drivers-locations-history`,
    DISPATCH_ROUTES: `${DISPATCH}/routes`,
    DISPATCH_ROUTES_HISTORY: `${DISPATCH}/routes/history`,
    DISPATCH_PLANNER: `${DISPATCH}/planner`,
    DISPATCH_SCHEDULE: `${DISPATCH}/schedule`,
    DISPATCH_SCHEDULE_SHIFT: (shiftId) => `${DISPATCH}/schedule/${shiftId}`,
    DISPATCH_SCHEDULE_PLANNING: `${DISPATCH}/schedule/planning`,
    DISPATCH_SCHEDULE_LIVE: `${DISPATCH}/schedule/live`,
    DISPATCH_SCHEDULE_LOGS: `${DISPATCH}/schedule/logs`,
    DISPATCH_SCHEDULE_DRIVER_AVAILABILITIES: `${DISPATCH}/schedule/driver-availabilities`,
    DISPATCH_REPORTS: `${DISPATCH}/reports`,
    DISPATCH_REPORTS_ORDERS: `${DISPATCH}/reports/orders`,
    DISPATCH_REPORTS_MAP: `${DISPATCH}/reports/map`,
    DISPATCH_REPORTS_TRANSACTIONS: `${DISPATCH}/reports/transactions`,
    DISPATCH_REPORTS_KPI: `${DISPATCH}/reports/kpi`,
    DISPATCH_REPORTS_PROFITABILITY: `${DISPATCH}/reports/profitability`,
    DISPATCH_NOTIFICATIONS: `${DISPATCH}/notifications`,
    DISPATCH_MERCHANTS: `${DISPATCH}/merchants`,
    DISPATCH_MERCHANTS_INACTIVE: `${DISPATCH}/merchants/inactive`,
    DISPATCH_INVOICE_MERCHANTS: `${DISPATCH}/invoice/merchants`,
    DISPATCH_INVOICE_DRIVERS: `${DISPATCH}/invoice/drivers`,
    DISPATCH_SETTINGS: `${DISPATCH}/settings`,
    DISPATCH_MENU: `${DISPATCH}/menu`,
    DISPATCH_TRACKING_HISTORY: `${DISPATCH}/tracking-history`,
    DISPATCH_ADDRESSES: `${DISPATCH}/addresses`,
    DISPATCH_BUSINESS: `${DISPATCH}/business`,
    DISPATCH_USERS: `${DISPATCH}/users`,
    DISPATCH_BILLING: `${DISPATCH}/billing`,
    DISPATCH_BILLING_INVOICES: `${DISPATCH}/billing/invoices`,
    DISPATCH_BILLING_PAYMENTS: `${DISPATCH}/billing/payments`,
    DISPATCH_SUPPORT: `${DISPATCH}/support`,
    DISPATCH_DOWNLOAD: `${DISPATCH}/download`,
    DISPATCH_AUTO_DISPATCH_SETTINGS: `${DISPATCH}/auto-dispatch-settings`,
    DISPATCH_ROUTING_GUIDE: `${DISPATCH}/routing-guide`,
    DISPATCH_DELIVERY_SERVICE_SETTINGS: `${DISPATCH}/delivery-service-settings`,
    DISPATCH_PROMO_CODE: `${DISPATCH}/promo-code`,
    DISPATCH_ZONES: `${DISPATCH}/settings/zones`,
    DISPATCH_PRINTNODE: `${DISPATCH}/settings/printnode`,
    DISPATCH_EXTERNAL_SHIPMENTS: `${DISPATCH}/external-shipments`,
    DISPATCH_DELIVERY_ZONES: `${DISPATCH}/delivery-service-settings?tab=zones`,
    
    // Merchant routes
    MERCHANT_DASHBOARD: `${MERCHANT}/dashboard`,
    MERCHANT_SEARCH: `${MERCHANT}/search`,
    MERCHANT_DELIVERIES: MERCHANT,
    MERCHANT_ORDER_DETAIL: (orid) => `${MERCHANT}/orders/${orid ?? ''}`,
    MERCHANT_DESTINATION_DETAIL: (id) => `${MERCHANT}/destinations/${id ?? ''}`,
    MERCHANT_BILLING_DETAIL: (id) => `${MERCHANT}/billing/${id ?? ''}`,
    MERCHANT_DRIVER_DETAIL: (id) => `${MERCHANT}/drivers/${id ?? ''}`,
    MERCHANT_ROUTE_DETAIL: (id) => `${MERCHANT}/routes/${id ?? ''}`,
    MERCHANT_SCHEDULES: `${MERCHANT}/schedules`,
    MERCHANT_ROUTES: `${MERCHANT}/routes`,
    MERCHANT_DRIVERS_ONLINE: `${MERCHANT}/drivers-online`,
    MERCHANT_REPORT: `${MERCHANT}/report`,
    MERCHANT_MAP_REPORT: `${MERCHANT}/map-report`,
    MERCHANT_MENU: `${MERCHANT}/menu`,
    MERCHANT_SUPPORT: `${MERCHANT}/support`,
    MERCHANT_MENU_NOTIFICATIONS: `${MERCHANT}/menu/notifications`,
    MERCHANT_MENU_INTEGRATIONS: `${MERCHANT}/menu/integrations`,
    MERCHANT_DESTINATIONS: `${MERCHANT}/destinations`,
    MERCHANT_DRIVERS: `${MERCHANT}/drivers`,
    MERCHANT_DRIVERS_LOCATIONS_HISTORY: `${MERCHANT}/drivers-locations-history`,
    MERCHANT_USERS: `${MERCHANT}/users`,
    MERCHANT_BILLING: `${MERCHANT}/billing`,
    MERCHANT_MERCHANTS: `${MERCHANT}/merchants`,
    MERCHANT_RECURRING: `${MERCHANT}/recurring`,
    MERCHANT_PAYMENT_INFO_SAVED: `${MERCHANT}/payment/info-saved-success`,
    MERCHANT_KITCHEN: `${MERCHANT}/kitchen`,
};

// Helper function to build dispatch routes
export const getDispatchRoute = (path) => {
    return `${ROUTES.DISPATCH}${path}`;
};

// Helper function to build merchant routes
export const getMerchantRoute = (path) => {
    return `${ROUTES.MERCHANT}${path}`;
};

